import React, { useMemo, useRef, useState } from "react";
import { LeftOutlined, RightOutlined } from "@ant-design/icons";
import "./visitlistblocks.css";
import VisitBlocksList from "./VisitBlocksList";
import { useReadMemory } from "../../../generic/hooks/useReadMemory";
import MemoryType from "../../../../service/memory/enum/MemoryType";
import ConfigurationConstants from "../../../utils/configurationconstants";
import { useRecoilValue } from "recoil";
import { currentConfiguration } from "../../../../service/memory/recoil/configurationstore";

const VisitBlocksListWrapper = ({ careplan }) => {
  const user = useReadMemory(MemoryType.USER);
  const configuration = useRecoilValue(currentConfiguration);
  const [startIndex, setStartIndex] = useState(0);
  const visitsPerPage = 5;
  const tagWidth = 30;
  const containerRef = useRef(null);

  const showFilledReports = useMemo(
    () =>
      Boolean(
        configuration[ConfigurationConstants.VISITBLOCKS_FILLED_REPORTS]
          ?.visibility,
      ),
    [configuration],
  );

  // all visits
  const visitList = careplan?.opportunities
    ?.flatMap((opportunity) => opportunity.tasks || []).sort((a, b) => b.createdTimestamp - a.createdTimestamp);

  // visits for coordinator
  const coordinatorVisits = visitList.filter(
    (item) =>
      showFilledReports ||
      !(
        item?.status === "Filled" &&
        item?.coordinatorIdentifier !== user?.userIdentifier
      )
  );

  // visits for volunteer
  const volunteerVisits = visitList?.filter(
    (item) =>
      item?.workforceIdentifier === user?.userIdentifier &&
      !(item?.status === "Filled" && item?.coordinatorIdentifier)
  );

  const visits =
    user.jobTitle === "Volunteer Coordinator"
      ? coordinatorVisits
      : volunteerVisits;

  const handleNext = () => {
    if (startIndex + visitsPerPage < visits.length) {
      setStartIndex((prev) => prev + visitsPerPage);
    }
  };

  const handlePrevious = () => {
    if (startIndex - visitsPerPage >= 0) {
      setStartIndex((prev) => prev - visitsPerPage);
    }
  };

  return (
    <div className="visit-blocks-wrapper mb-1">
      {visits?.length > visitsPerPage && (
        <LeftOutlined
          onClick={handlePrevious}
          style={{
            cursor: startIndex === 0 ? "not-allowed" : "pointer",
            color: startIndex === 0 ? "#ccc" : "#000",
          }}
        />
      )}

      <div
        ref={containerRef}
        style={{
          overflow: "hidden",
          width: visitsPerPage * tagWidth + 32,
        }}
      >
        <VisitBlocksList
          tagWidth={tagWidth}
          careplan={careplan}
          visitList={visits.slice(startIndex, startIndex + visitsPerPage)}
        />
      </div>

      {visits?.length > visitsPerPage && (
        <RightOutlined
          onClick={handleNext}
          style={{
            cursor:
              startIndex + visitsPerPage >= visits?.length
                ? "not-allowed"
                : "pointer",
            color:
              startIndex + visitsPerPage >= visits?.length ? "#ccc" : "#000",
          }}
        />
      )}
    </div>
  );
};

export default VisitBlocksListWrapper;
